if (!customElements.get('push-cart-item')) {
  customElements.define(
    'push-cart-item',
    class PushCartItem extends window.BAO.CustomElement {
      _loading = false
      sections = window.BAO.utils.sectionRenderer.pushCartSections

      setupListeners () {
        super.setupListeners()

        this.removeLineItem = this.removeLineItem.bind(this)
        this.updateQuantity = this.updateQuantity.bind(this)

        if (this.els?.remove.exists) {
          this.listeners.add(
            this.els.remove.element,
            'click',
            this.removeLineItem,
          )
        }

        if (this.els?.quantity?.exists) {
          this.listeners.add(
            this.els.quantity.element,
            'change',
            this.updateQuantity,
          )
        }
      }

      async removeLineItem () {  
        const state = await window.BAO.Cart.removeItem(
          this.line,
          this.sections.map(s => s.section),
        )

        this.removeLineItemsByProperty('__gwp', true);
        if ('sections' in state) this.renderSections(state.sections)       
      }

      async updateQuantity (e) {
       
        const state = await window.BAO.Cart.updateQuantity(
          this.line,
          parseInt(e.target.value, 10),
          this.sections.map(s => s.section),
        )

        this.removeLineItemsByProperty('__gwp', true);
        if ('sections' in state) this.renderSections(state.sections)
          
      }

      removeLineItemsByProperty(propertyName, propertyValue) {
        let itemsToRemove = [];
        // Fetch the current cart
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            console.log(cart)
            itemsToRemove = cart.items.filter(item => {
              return item.properties && item.properties[propertyName] === propertyValue;
            });
      
            // If there are no items to remove, exit the function
            if (itemsToRemove.length === 0) {
              console.log('No items found with the specified property.');
              return;
            }
      
            // Prepare an array of promises to remove each item
            const removalPromises = itemsToRemove.map(item => {
              const lineItemId = item.id;
              return fetch(`/cart/update.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  updates: {
                    [lineItemId]: 0 // Setting the quantity to 0 removes the item
                  }
                })
              });
            });
      
            // Wait for all removals to complete
            return Promise.all(removalPromises);
          })
          .then(() => {
            
           if (itemsToRemove.length !== 0) {
            console.log('Items removed successfully.');
            window.location.reload(); // to refresh the cart page
             // this.renderSections(state.sections) -- better to fix this
            } else {
              console.log('No need to remove items');
            }
            
            
          })
          .catch(error => {
            console.error('Error removing items from cart:', error);
          });

      }

      get loading () {
        return this._loading
      }

      set loading (val) {
        this._loading = val
      }

      get line () {
        return parseInt(this.getAttribute('index'), 10)
      }
    },
  )
}
